import { render, staticRenderFns } from "./summary-page.vue?vue&type=template&id=7a60448d&scoped=true&"
import script from "./summary-page.vue?vue&type=script&lang=js&"
export * from "./summary-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a60448d",
  null
  
)

export default component.exports